import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMethod } from "../../services/ApiCallMethods";

export const getOwnerEntitiesGrouped = createAsyncThunk(
  "accountGrouped/getOwnerEntitiesGrouped",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getMethod("/account/getOwnerEntitiesGrouped");
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || "Failed to fetch grouped accounts");
      }

      return data;
    } catch (error) {
      return rejectWithValue(
        error?.message || "Failed to fetch grouped accounts"
      );
    }
  }
);

const initialState = {
  ownerEntitiesGrouped: null,
  loading: false,
  error: null,
  success: false,
};

const accountGroupedInvestmentSlice = createSlice({
  name: "accountGrouped",
  initialState,
  reducers: {
    clearAccountGroupedState: (state) => {
      state.ownerEntitiesGrouped = null;
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getOwnerEntitiesGrouped.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getOwnerEntitiesGrouped.fulfilled, (state, action) => {
        state.loading = false;
        state.ownerEntitiesGrouped = action.payload?.data;
        state.success = true;
      })

      .addCase(getOwnerEntitiesGrouped.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Unable to fetch grouped accounts";
        state.success = false;
      });
  },
});

export const { clearAccountGroupedState } = accountGroupedInvestmentSlice.actions;
export default accountGroupedInvestmentSlice.reducer;
